import { ThemeUICSSObject, focusOutline, spacing } from '@apia/theme';
import { interpolateColor } from '../../../../components/apia/design/ProjectAnalysis/ProjectAnalysisTree/modals/implementations/CostsModal/scenes/schedule/RolesHoursCountTable';
/* IMPORT HERE */

const bpmnMapViewportStyles: ThemeUICSSObject = {
  alignItems: 'center',
  background: 'palette.background.default',
  cursor: 'grab',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  minHeight: 0,
  overflow: 'hidden',
  p: 4,
  position: 'relative',
  touchAction: 'none',
  userSelect: 'none',
  width: '100%',

  '&.previewAccordion__imageViewport--panning': {
    cursor: 'grabbing',
  },

  '.previewAccordion__imageContent': {
    display: 'block',
    flex: '0 0 auto',
    position: 'relative',
    willChange: 'height, left, top, width',
  },

  img: {
    objectFit: 'contain',
  },

  '.previewAccordion__inlineSvg': {
    cursor: 'grab',

    svg: {
      display: 'block',
      height: '100%',
      overflow: 'visible',
      width: '100%',
    },

    'rect.bpa-map-task, g.bpa-map-task > rect, polygon.bpa-map-gateway, g.bpa-map-gateway > polygon, .bpa-map-edge-line':
      {
        transition: 'stroke 120ms ease, stroke-width 120ms ease',
      },

    '.bpa-map-task, .bpa-map-gateway': {
      cursor: 'pointer',
    },

    '.bpa-map-event': {
      cursor: 'pointer',
    },

    '.bpa-map-text, line, .bpa-map-gateway ellipse': {
      pointerEvents: 'none',
    },

    'rect.bpa-map-task.bpa-map-hover, g.bpa-map-task.bpa-map-hover > rect': {
      stroke: 'palette.primary.main',
      strokeWidth: 5,
    },

    'polygon.bpa-map-gateway.bpa-map-hover, g.bpa-map-gateway.bpa-map-hover > polygon':
      {
        stroke: 'palette.primary.main',
        strokeWidth: 5,
      },

    'g.bpa-map-event.bpa-map-hover > circle': {
      stroke: 'palette.primary.main',
      strokeWidth: 5,
    },

    '.bpa-map-edge': {
      cursor: 'pointer',
    },

    '.bpa-map-edge-hit': {
      pointerEvents: 'stroke',
    },

    '.bpa-map-edge.bpa-map-hover .bpa-map-edge-line': {
      stroke: 'palette.primary.main',
      strokeWidth: 4,
    },

    '.bpa-map-edge.bpa-map-hover--outgoing .bpa-map-edge-line': {
      stroke: 'palette.primary.main',
      strokeWidth: 4,
    },

    '.bpa-map-edge.bpa-map-hover--incoming .bpa-map-edge-line': {
      stroke: 'palette.success.dark',
      strokeWidth: 4,
    },
  },

  '.previewAccordion__imageToolbar': {
    alignItems: 'center',
    background: 'rgba(255, 255, 255, 0.88)',
    border: '1px solid',
    borderColor: 'palette.border.field',
    borderRadius: '4px',
    bottom: 3,
    boxShadow: 'default',
    display: 'flex',
    gap: 1,
    p: 1,
    position: 'absolute',
    right: 3,
    zIndex: 2,
  },
};

const projectAnalysis: ThemeUICSSObject = {
  height: '100%',
  width: '100%',

  '.projectAnalysis__generator': {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(4),
    '.projectAnalysis__generator__header': {
      borderBottom: '1px solid',
      borderBottomColor: 'palette.border.section',
      heading: {},
    },
  },

  tree: {
    '.tree__nodeItemLabelRenderer': {
      ml: 2,

      '.iconButton': {
        opacity: 0,
        transition: 'opacity 50ms',
      },

      '&:hover': {
        '.iconButton': {
          opacity: 1,
        },
      },

      '.renderer__buttons': {
        display: 'flex',
        gap: '2px',

        'button:disabled': {
          svg: (theme) =>
            theme.palette.getOneState(
              { backgroundColor: theme.palette.primary.main },
              'disabled',
            ),
          cursor: 'not-allowed',
        },
      },
    },

    '.collection__renderer': {
      display: 'flex',
      alignItems: 'center',
      gap: 3,
    },

    '.tree__item': {
      '.analysisTreeItem__name': {
        fontSize: '14px',
        color: '#ddd',
        '&:hover': {
          color: 'black',
          /** NO BORRAR */
          zIndex: 1,
        },
      },

      '&:hover': {
        '& > .tree__nodeItemLabel': {
          '.analysisTreeItem__name, .collection__renderer': {
            textDecoration: 'underline',
            color: 'palette.text.primary',

            '&.analysisTreeItem__name': {
              fontWeight: 'bold',
              /** NO BORRAR */
              zIndex: 1,
            },
          },
        },
      },
    },
  },

  '.tree': {
    variant: 'layout.design.projectAnalysis.tree',
  },

  abstractItemRenderer: {
    display: 'flex',
    alignItems: 'center',
    gap: 3,
  },

  activitiesTable: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    alignItems: 'end',

    '.noBorder-left': {
      borderLeft: 'none !important',
    },
    '.noBorder-right': {
      borderRight: 'none !important',
    },
    '.noBorder-bottom': {
      borderBottom: 'none !important',
    },

    table: {
      variant: 'layout.common.tables.primary',
      border: 'none !important',

      'td.middle': {
        textAlign: 'center',
        verticalAlign: 'middle',
      },

      '.percent__wrapper': {
        gap: 0,
      },

      '.percent__label': {
        pt: 3,
      },

      '.percent__wrapper input': {
        pb: 0,
        pr: 0,
      },

      '.wrong__total': {
        background: 'palette.warning.main',
      },

      '& thead': {
        'tr.horizontal': {
          th: {
            height: 'auto',
            writingMode: 'initial',
          },
        },

        th: {
          top: '0 !important',
          fontWeight: '600 !important',
          height: '180px',
          fontSize: '17px !important',
          writingMode: 'vertical-rl',

          '&:nth-of-type(1)': {
            width: '40px',
          },

          '&:nth-of-type(2)': {
            width: '200px',
          },

          '&:nth-of-type(4)': {
            width: '24px',
          },
        },
      },

      '& tbody': {
        'tr.activities__distribution': {
          '&, & *': {
            '&.wrong__total': {
              background: 'palette.warning.main  !important',
            },
          },
        },

        th: {
          textAlign: 'left',
          p: 3,
          zIndex: '0 !important',
        },

        td: {
          background: 'palette.background.paper',
          padding: 0,

          input: {
            textAlign: 'center',
          },
        },

        '.vertical': {
          writingMode: 'vertical-rl',
          transform: 'rotate(180deg)',
        },

        '.roles__title': {
          textAlign: 'center',
          verticalAlign: 'middle',
          background: 'palette.background.paper',
          border: '1px solid',
          borderColor: 'palette.border.article',
          position: 'static',
        },
      },

      '[class*="separator"]': {
        background: 'palette.background.paper',
        border: 'none',

        '&.separator-horizontal': {
          height: '24px',

          td: {
            '&:nth-of-type(1)': {
              borderBottom: '1px solid',
              borderColor: 'palette.border.article',
              borderRight: 'none',
              borderTop: '1px solid',
            },
            '&:nth-of-type(2)': {
              border: 'none',
            },
            '&:nth-of-type(3)': {
              borderLeft: 'none',
              borderBottom: '1px solid',
              borderColor: 'palette.border.article',
              borderTop: '1px solid',
            },
          },
        },

        '&.separator-vertical': {
          width: '24px',

          borderLeft: '1px solid',
          borderRight: '1px solid',
          borderColor: 'palette.border.article',
        },
      },
    },
  },

  affectedPathsQuestionBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,

    '.question': {
      fontWeight: 'bold',
    },

    ul: {
      listStyle: 'square',
      ml: '24px',
    },
  },

  autofillModal: {
    '.modal__main': { width: '100vw' },

    form: {
      flexDirection: 'column',
    },

    '.fieldWrapper.checkbox, .fieldLabel.checkbox': {
      display: 'flex',
      flexDirection: 'row-reverse',
      gap: 3,
      alignItems: 'center',
      justifyContent: 'center',

      '&.fieldLabel > *': {
        display: 'flex',
      },
    },

    '.collapsiblePanel__label': {
      background: 'palette.background.paper',
      border: '1px solid',
      borderColor: 'palette.border.field',
      position: 'sticky',
      top: 0,

      'button.collapsiblePanel__label__button': {
        fontSize: 17,
        py: 3,
        variant: 'text.title',
        width: '100%',
      },
    },

    '.collapsiblePanel__content > div': {
      alignItems: 'start',
      background: 'palette.background.default',
      border: '1px solid',
      borderColor: 'palette.border.section',
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      p: 4,
    },

    '.autofill__item, .sheet': {
      background: 'palette.background.paper',
      border: '1px solid',
      borderColor: 'palette.border.section',
      borderRadius: 'radii',
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      p: 4,
      width: '100%',

      '&.sheet': {
        alignItems: 'start',
        gap: 2,
      },
    },

    '.autofill__item__inputs': {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 3,
    },

    '.confirm': {
      overflow: 'auto',
    },

    '.confirm__content': {
      gap: 3,
    },
  },

  collectionPicker: {
    width: '500px',

    '.modal__main': {
      height: '75vh',
    },

    '.collectionPicker__content': {
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
      overflow: 'auto',
      position: 'relative',
      pr: 3,

      '.collectionPicker__item': {
        variant: 'buttons.link',
        border: '1px solid',
        justifyContent: 'start',
        p: 0,
        textAlign: 'left',
        textDecoration: 'none',
      },

      '.collectionPicker__searchbox': {
        position: 'sticky',
        top: 0,
        zIndex: 'stickyElements',
      },
    },
  },

  costsDetailsTooltip: {
    '&.costsDetailsTooltip': {
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
      width: '600px',
    },

    '.counters': {
      p: 3,
      border: '1px solid',
      borderColor: 'palette.border.section',
    },

    '.withInfoButton': {
      display: 'flex',
      justifyContent: 'space-between',
    },
  },

  configurationModal: {
    width: '98vw',
    height: '98vh',

    '& .modal__main > div.modal__content': {
      padding: '0',
      overflow: 'hidden',
      display: 'flex',
    },

    mainColorWrapper: {
      display: 'flex',
      gap: 3,

      'select, .autocomplete': {
        flexGrow: 1,
      },

      '.preview': {
        flexShrink: 0,
        height: '50px',
        width: '50px',
      },
    },

    layout: {
      display: 'flex',
      height: '100%',
      overflow: 'hidden',

      '.costs__main': {
        height: '100%',
        width: '100%',
        overflow: 'auto',
        background: 'palette.background.default',
        display: 'block',
        padding: 5,
      },

      '.costs__main__sheet': {
        background: 'palette.background.paper',
        width: '800px',
        border: '1px solid',
        borderColor: 'palette.border.section',
        boxShadow: 'panel',
        margin: 'auto',
        p: 6,

        '&.extended': {
          width: '100%',
        },

        '.collapsiblePanel__label': {
          background: 'palette.background.paper',
          border: '1px solid',
          borderColor: 'palette.border.section',

          position: 'sticky',
          top: '-16px',
          zIndex: 2,

          button: {
            p: 6,
            width: '100%',
          },
        },

        '.-<': {
          border: '1px solid',
          borderColor: 'palette.border.section',
          borderTop: 'none',
          background: 'palette.background.default',
          p: 6,

          '.omitted, .omitted *': {
            background: '#ccc',
          },
        },

        '.costs__fields__grid': {
          background: 'palette.background.paper',
          border: '1px solid',
          borderColor: 'palette.border.article',
          display: 'grid',
          gap: 6,
          p: 6,

          '.variableCosts__table': {
            gridColumnStart: 1,
            gridColumnEnd: 3,
          },

          '&.no__padding': {
            p: 0,
            border: 'none',
          },
        },

        '.rah-static--height-zero.collapsiblePanel__content table th, .rah-animating.collapsiblePanel__content table th':
          {
            position: 'static',
            top: 'auto',
            zIndex: 0,
          },

        table: {
          background: 'palette.background.paper',
          border: '1px solid',
          borderColor: 'palette.border.section',
          maxWidth: '100%',
          tableLayout: 'fixed',

          th: {
            position: 'sticky',
            top: '60px',
            zIndex: 1,
          },

          td: {
            textWrap: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',

            'input, select': {
              border: 'none',
            },

            'button[role="checkbox"]': {
              height: '48px',
              width: '100%',
              border: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',

              svg: {
                height: '16px',
                width: '16px',
              },
            },

            '&.variableCosts': {
              padding: 0,

              strong: {
                display: 'block',
                textAlign: 'center',
                p: 3,
                pb: 0,
              },
            },
          },
        },
      },

      '.costs__aside': {
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
        gap: 3,
        overflow: 'auto',
        p: 3,
        width: '400px',
      },

      'input[type="color"]': {
        height: '70px',
      },
    },

    toolbar: {
      '.toolbar': {
        background: 'palette.background.paper',
        borderBottom: '1px solid',
        borderBottomColor: 'palette.border.section',

        '.modal__title': {
          mr: 4,
          fontWeight: 'bold',
        },

        '[data-id="close"]': {
          marginLeft: 'auto',
        },
      },
    },

    '.costsModal__pricing': {
      '.pricing__weekSummary': {
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
      },

      '.pricing__selectWeek': {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        gap: 3,

        '*': {
          flexGrow: 1,
        },

        '.fieldLabel__label': {
          flexShrink: 0,
          flexGrow: 0,
        },
      },
    },

    '.costs__summary': {
      border: '1px solid',
      borderColor: 'palette.border.section',
      p: 6,
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: 3,

      h2: {
        fontSize: 19,
        mb: 4,
      },

      '.summaryItem': {
        display: 'flex',
        justifyContent: 'space-between',

        button: {
          display: 'none',
        },

        '&.editable:hover': {
          button: {
            display: 'inline-block',
          },
        },

        '.summaryItem__cost': {
          fontWeight: 'bold',

          input: {
            display: 'inline',
            width: '100px',
          },
        },

        '&.separate': {
          pt: 5,
        },

        '&.total': {
          fontSize: 17,
          fontWeight: 'bold',
        },
      },
    },

    '.modal__main': {
      maxWidth: '100%',
      maxHeight: '100%',
      width: '100%',
      height: '100%',
    },

    '.sheet': {
      p: 6,
      background: 'palette.background.paper',
      border: '1px solid',
      borderColor: 'palette.border.article',
      display: 'flex',
      flexDirection: 'column',
      gap: 3,

      '&:focus-within': {
        boxShadow: 'panel',
      },
    },
  },

  creationModal: {
    width: 'min(600px, 95vw)',

    '.modal__content': {
      gap: 3,
    },

    '.confirm__content': {
      gap: 3,
    },

    '.creationModal__itemPicker': {
      variant: 'buttons.outline',
    },
  },

  deliverables: {
    alignItems: 'end',
    p: 6,
    background: 'palette.background.default',

    ul: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },

    '.deliverable__info': {
      flexGrow: '1',
    },

    '.sortableList__item': {
      display: 'flex',
      py: 3,

      '&:hover': {
        '.deliverable__buttons': {
          opacity: 1,
        },
      },
    },

    '.deliverable__buttons': {
      opacity: 0,
      flexShrink: '0',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '4px',
      transition: 'opacity 0.3s',
    },

    '.toolbar': {
      justifyContent: 'end',
    },
  },

  entityInstanceEdition: {
    '.field__content': {
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'wrap',
      gap: 3,
      justifyContent: 'space-between',

      '.field__content__edit': {
        display: 'flex',
        width: '100%',

        '& > *:not(button)': {
          width: '100%',
        },

        '& > button': {
          flexShrink: 0,
          width: '50px',
          height: '50px',
        },
      },

      '&.updating': {
        p: 0,
      },

      '.edit__button': {
        opacity: 0,
        transition: '200ms opacity',

        '&:focus': {
          opacity: 1,
        },
      },

      '.iconInput': {
        width: '100%',

        input: {
          border: 'none',
        },

        button: {
          border: 'none',
        },
      },

      '&:hover': {
        '.edit__button': {
          opacity: 1,
        },
      },

      '.relativePositionedEditionField': {
        position: 'relative',

        '& > *': {
          position: 'absolute',
          background: 'palette.background.paper',
        },
      },
    },
  },

  fields: {
    percentAndHours: {
      display: 'inline-flex',
      flexDirection: 'column',
      width: '100%',

      '&:focus-within': focusOutline,

      '& > *': {
        display: 'flex',
        alignItems: 'center',
        gap: 3,
        justifyContent: 'center',
      },

      '.percent__label': {
        pr: 5,
      },

      '.percent__wrapper input': {
        background: 'transparent',
        p: 3,
        pr: 0,
        textAlign: 'right',

        '&:focus': {
          outline: 'none',
        },
      },
    },
  },

  form: {
    display: 'grid',
    gridTemplateColumns: 'repeat(1, 1fr)',
    gap: spacing(4),
    '.textarea': {
      textarea: {
        height: '30vh',
        mt: spacing(1),
      },
    },
  },

  imageFieldDetails: {
    alignItems: 'start',
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    p: 4,

    img: {
      flexBasis: '64px',
      width: '64px',
    },

    '.buttons__container': {
      display: 'flex',
      flexDirection: 'row',
      gap: 3,
    },
  },

  imagesLoader: {
    display: 'flex',
    overflow: 'hidden',
    alignItems: 'stretch',
    justifyContent: 'stretch',
    gap: 3,
    height: '100%',

    '.images_sort_wrapper': {
      overflow: 'auto',
      p: 3,
      width: '150px',

      '&:focus': {
        outline: 'none',
      },
    },

    '.sortableList__item': {
      background: '#333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    '.sortableList__item img': {
      maxWidth: '150px',
      maxHeight: '150px',
      py: 3,
    },

    '.sortableList': {
      flexBasis: '170px',
      flexShrink: 0,
      gap: 3,
    },

    '.image_editor': {
      flexBasis: '100%',
      gap: 3,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      maxHeight: '100%',
      flexShrink: '1',
    },

    '.image_preview': {
      background: '#333',
      flexBasis: '100%',
      overflow: 'hidden',
      flexShrink: '1',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',

      img: {
        height: '100%',
      },

      '.iconButton': {
        position: 'absolute',
        right: '2px',
        top: '2px',
      },
    },

    '.image_description': {
      flexShrink: 0,
      flexBasis: '80px',
      position: 'relative',

      textarea: {
        minHeight: '80px',
        height: '80px',
      },

      '.iconButton': {
        position: 'absolute',
        right: '8px',
        top: '8px',
      },
    },
  },

  itemDetailsModal: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',

    '&>*:last-child': {},

    '.itemDetails__references': {
      '& > label': {
        mt: 6,
        mb: 4,
        textDecoration: 'underline',
        fontSize: '18px',
      },
    },

    th: {
      textWrap: 'nowrap !important' as any, // No le gusta el !important
      verticalAlign: 'middle !important' as any,
    },
  },

  itemDetailsReferences: {
    variant: 'layout.common.tables.information',
    width: '100%',
    borderColor: 'palette.border.article',

    '& tbody': {
      tr: {
        th: {
          maxWidth: '30%',
          minWidth: 'max-content',
          width: 'auto',
          whiteSpace: 'pre-wrap',
          borderColor: 'palette.border.article',
          '&:not(th:last-child)': {
            borderRightColor: 'palette.border.article',
          },
        },
        td: {
          borderColor: 'palette.border.article',
          p: 0,
          width: '100%',
        },
      },
    },

    '.iconButton:disabled': {
      color: '#ccc',
      cursor: 'not-allowed',
    },

    '.field__content': {
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'wrap',
      gap: 3,
      justifyContent: 'space-between',
      p: 3,
      pl: 4,
      minWidth: '500px',

      '&.field__references': {
        justifyContent: 'start',

        '.itemDetails__referenceButton': {
          alignItems: 'center',
          display: 'flex',

          button: {
            variant: 'buttons.link',
          },

          '.iconButton': {
            display: 'block',
            height: '100%',
            opacity: 0,
            transition: 'opacity 200ms',
          },

          '&:hover, &:focus, &:focus-within': {
            '.iconButton': {
              opacity: 1,
            },
          },
        },
      },

      '.field__content__edit': {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',

        '& > *:not(button)': {
          width: '100%',
        },

        '& > button': {
          flexShrink: 0,
          width: '50px',
          height: '50px',
        },

        '.checkbox': {
          display: 'flex',
          alignItems: 'center',
          p: 3,
          pl: 4,
        },
      },

      '&.updating': {
        p: 0,
      },

      '.edit__button': {
        opacity: 0,
        transition: '200ms opacity',

        '&:focus': {
          opacity: 1,
        },
      },

      '.iconInput': {
        width: '100%',

        input: {
          border: 'none',
        },

        button: {
          border: 'none',
        },
      },

      '&:hover': {
        '.edit__button': {
          opacity: 1,
        },
      },

      '.relativePositionedEditionField': {
        position: 'relative',

        '& > *': {
          position: 'absolute',
          background: 'palette.background.paper',
        },
      },
    },
  },

  itemRemovalModal: {
    variant: 'layout.common.modals.confirm',
    width: '500px',

    '.modal__main': {
      height: 'auto',
    },

    '.confirm__content': {
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
    },

    '.cannotRemove__affectedPaths': {
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
    },

    '.cannotRemove__item': {
      width: '100%',
      justifyContent: 'start',
      span: { textAlign: 'left' },
      padding: 0,
    },
  },

  mergeModal: {
    variant: 'layout.util.collector.modal',

    '.MergeCheckbox > div': {
      display: 'flex',
      alignItems: 'center',
      gap: 3,
    },
  },

  mergeStrategy: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,

    '.mergeStrategy__question': {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,

      p: { m: 0 },
    },
    '.mergeStrategy__options': {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,

      button: {
        borderWidth: '1px',
        justifyContent: 'start',
      },
    },
    '.mergeStrategy__consistence': {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
    },
  },

  modal: {
    '.modal__main': {
      height: 'auto',
    },

    '.confirm__content': {
      overflow: 'auto',
    },
  },

  nameEdition: {
    '&.projectAnalysis__nameEdition': {
      border: 'none',
      background: 'transparent',
      fontSize: 19,
      fontWeight: 'normal',
      color: 'palette.text.primary',

      '&:focus': {
        border: '1px solid',
        borderColor: 'palette.border.section',
      },
    },
  },

  notesModal: {
    '.modal__content': {
      p: '0 !important',
    },

    '.modal__main': {
      width: 'auto',
      minWidth: '100px',
      maxWidth: '90vw',
      maxHeight: '95vh',

      '[data-variant="layout.util.collector.formContainer"], form': {
        height: '100%',
      },

      '.collector__field.WysiwygEditor': {
        height: '100%',

        '.fieldWrapper': {
          p: 5,
          height: 'calc(100% - 40px)',
          overflow: 'auto',
        },

        '.fieldWrapper:focus-within': focusOutline,

        pre: {
          '&.public-DraftStyleDefault-pre': {
            background: '#eee',
            font: 'courier new',
            m: 3,
            marginRight: 0,
            p: 3,
          },

          '&[data-block="true"]': {
            m: 0,
          },
        },
      },
    },
  },

  promptTextarea: {
    position: 'relative',

    '.augment_prompt': {
      position: 'absolute',
      right: '4px',
      top: '4px',
    },
  },

  proposal: {
    alignItems: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    gap: 6,

    'h3:not(:first-of-type)': {
      mt: 6,
    },

    '.toolbar': {
      justifyContent: 'end',
    },

    '.proposal__controls, .proposal__controls .fieldLabel, .proposal__controls .fieldLabel *':
      {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        gap: 3,
        justifyContent: 'end',
      },

    '.proposal__diagram': {
      variant: 'layout.common.tables.primary',

      width: 'auto',
      minWidth: '100%',
      maxWidth: 'unset',

      '& thead': {
        position: 'static',

        'th:first-of-type': {
          left: '-8px',
          zIndex: 2,
        },

        th: {
          minWidth: '80px',
          position: 'sticky',
          top: '-24px',
        },
      },

      '& tbody': {
        th: {
          textAlign: 'left',
          position: 'sticky',
          width: '150px',
          maxWidth: '150px',
          minWidth: '150px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          top: 0,
          left: '0',
          zIndex: 2,
          background: 'palette.background.paper',
          borderBottom: '1px solid',
          borderBottomColor: 'palette.border.section',
        },

        td: {
          cursor: 'pointer',
          width: '80px',
          maxWidth: '80px',
          minWidth: '80px',
        },

        'td.selected': {
          backgroundColor: 'palette.primary.main',
          borderColor: 'palette.primary.main',
        },

        'td:not(.selected)': {
          background: '#f5f5f5',
        },
      },
    },

    '.overflowX': {
      overflowX: 'auto',
    },

    '.proposal__weeks__wrapper': {
      background: 'palette.background.default',
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
      p: 3,
      width: '100%',

      thead: {
        th: {
          width: '',
        },
      },
    },

    '.proposal__weeks__details': {
      background: 'palette.background.default',
      display: 'grid',
      gap: 3,
      gridTemplateColumns: 'repeat(3, 1fr)',
      p: 3,
      width: '100%',

      '.proposal__week__details': {
        background: 'palette.background.paper',
        border: '1px solid',
        borderColor: 'palette.border.article',
        borderRadius: 3,
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        p: 3,

        '.hover': {
          backgroundColor: interpolateColor(0, 100, 20, 1),
        },
      },
    },
  },

  bpmnMapPreviewModal: {
    width: '100vw',
    height: '100vh',
    maxWidth: '100vw',
    maxHeight: '100vh',
    m: 0,
    border: 'none',
    borderRadius: 0,
    overflow: 'hidden',

    '.modal__main': {
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      maxHeight: '100vh',
      m: 0,
      border: 'none',
      borderRadius: 0,
      boxShadow: 'none',
      p: 0,
      resize: 'none',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      justifyItems: 'stretch',
      gap: 0,
      overflow: 'hidden',
    },

    '.modal__main > div.modal__content': {
      p: 0,
      flex: '1 1 auto',
      minHeight: 0,
      overflow: 'hidden',
      border: 'none',
    },

    '.bpmnMapPreviewModal__content': {
      height: '100%',
      minHeight: 0,
      minWidth: 0,
      overflow: 'hidden',
      width: '100%',
    },

    '.previewAccordion__imageViewport': {
      ...bpmnMapViewportStyles,
    },
  },

  regenModal: {
    width: '100vw',
    height: '100vh',
    maxWidth: '100vw',
    maxHeight: '100vh',
    m: 0,
    border: 'none',
    borderRadius: 0,
    overflow: 'hidden',

    '.first__right__button': {
      ml: 'auto',
    },

    '.toolbarContainer select.toolbar__select[name="process__completion__method"]':
      {
        width: '150px',
        marginRight: '4px',
      },

    '.modal__main': {
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      maxHeight: '100vh',
      m: 0,
      border: 'none',
      borderRadius: 0,
      boxShadow: 'none',
      p: 0,
      resize: 'none',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      justifyItems: 'stretch',
      gap: 0,
      overflow: 'hidden',
    },

    '.modal__main > div.modal__content': {
      p: 0,
      flex: '1 1 auto',
      minHeight: 0,
      overflow: 'hidden',
      border: 'none',
    },

    '.regenerate__item': {
      height: '100%',
      minHeight: 0,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',

      '.workArea': {
        flex: '1 1 auto',
        display: 'grid',
        gridTemplateColumns:
          'minmax(50px, var(--chat-column, 30fr)) 4px minmax(50px, var(--prompt-column, 35fr)) 4px minmax(50px, var(--preview-column, 35fr))',
        gap: 0,
        alignItems: 'stretch',
        overflow: 'hidden',
        minHeight: 0,

        '.resize__handle': {
          position: 'relative',
          cursor: 'col-resize',
          minWidth: '4px',
          width: '4px',
          height: '100%',
          outline: 'none',
          background: 'transparent',
          transition: 'background 200ms',

          '&:hover': {
            backgroundColor: 'palette.border.field',
          },
        },

        '.generatorSection--hidden': {
          display: 'none !important',
        },

        '.generatorSection__header': {
          alignItems: 'center',
          background: 'palette.background.paper',
          borderBottom: '1px solid',
          borderColor: 'palette.border.field',
          display: 'flex',
          flex: '0 0 36px',
          gap: 2,
          minHeight: '36px',
          px: 2,
        },

        '.generatorSection__title': {
          color: 'palette.text.primary',
          flex: '1 1 auto',
          fontSize: '12px',
          fontWeight: 600,
          lineHeight: '16px',
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },

        '.generatorSection__routeNavigation': {
          alignItems: 'center',
          display: 'flex',
          flex: '0 0 auto',
          gap: 1,
          ml: 'auto',
        },

        '.previewIconButton.iconButton': {
          background: 'transparent',
          border: 'none',
          borderRadius: 'panel',
          color: 'palette.text.primary',
          flexShrink: 0,
          height: '34px',
          minHeight: '34px',
          minWidth: '34px',
          width: '34px',

          '&.isToggled': {
            background: 'palette.primary.main',
            color: 'palette.primary.contrastText',
          },
        },

        '.chat__area': {
          border: '1px solid',
          borderColor: 'palette.border.field',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          minHeight: 0,
          minWidth: 0,
          overflow: 'hidden',

          '.chat__area__content': {
            display: 'flex',
            flex: '1 1 auto',
            minHeight: 0,
            minWidth: 0,
            overflow: 'hidden',
          },

          '.chat_controller': {
            flexGrow: 1,
            minHeight: 0,
            minWidth: 0,
          },

          '.promptEnhancementChat__history': {
            flex: '1 1 auto',
            minHeight: 0,

            '.chat_history': {
              gap: 0,
            },

            '.history_message': {
              display: 'flex',
              flexDirection: 'column',

              '&.last, &.first:has(+ .first)': {
                mb: 0,
              },

              '.message__body.markdown': {
                'h1, h2, h3, h4, h5, h6': {
                  color: 'inherit',
                  fontWeight: 600,
                  letterSpacing: 0,
                  lineHeight: '1.35',
                  m: 0,
                  mb: '14px',
                },

                'h1:not(:first-child), h2:not(:first-child), h3:not(:first-child), h4:not(:first-child), h5:not(:first-child), h6:not(:first-child)':
                  {
                    mt: '30px',
                  },

                'h1, h2': {
                  fontSize: '1.12em',
                  mb: '16px',
                },

                h3: {
                  fontSize: '1.06em',
                  mb: '12px',
                },

                'h4, h5, h6': {
                  fontSize: '1em',
                  mb: '10px',
                },

                p: {
                  m: 0,
                  mb: '12px',
                },

                'p + p': {
                  mt: '10px',
                },

                'ul + p, ol + p': {
                  mt: '14px',
                },

                'p:last-child': {
                  mb: 0,
                },

                hr: {
                  display: 'none',
                },

                'li > p': {
                  m: 0,
                },

                'li > p + p': {
                  mt: '6px',
                },
              },
            },

            '.history_message.customMessage': {
              alignSelf: 'stretch',
              background: 'transparent',
              border: 'none',
              borderRadius: 0,
              maxWidth: '100%',
              minWidth: 0,
              p: 0,
              pt: 0,
              whiteSpace: 'normal',
              width: '100%',

              '.history_message__content': {
                display: 'block',
                gap: 0,
                width: '100%',
              },
            },

            '.history_message + .history_message': {
              mt: '8px',
            },

            '.history_message:has(.chatAssistantStackSegment--text) + .history_message:has(.chatAssistantStackSegment--text), .history_message:has(.chatAssistantStackSegment--block) + .history_message:has(.chatAssistantStackSegment--block)':
              {
                mt: '2px',
              },

            '.history_message__references': {
              mb: 2,
              order: -1,
              width: '100%',
            },
          },
        },

        '.result__preview': {
          p: 4,
          height: '100%',
          minHeight: 0,
          minWidth: 0,
          overflow: 'auto',
          borderLeft: '1px solid',
          borderTop: '1px solid',
          borderColor: 'palette.border.field',

          '&.result__preview--tree': {
            background: 'palette.background.default',
            display: 'flex',
            flexDirection: 'column',
            gap: 0,
            overflow: 'hidden',
            p: 0,

            '.previewAccordion__header': {
              alignItems: 'center',
              background: 'palette.background.paper',
              borderBottom: '1px solid',
              borderColor: 'palette.border.field',
              display: 'flex',
              flex: '0 0 36px',
              gap: 2,
              minHeight: '36px',
              px: 2,
            },

            '.previewAccordion__title': {
              color: 'palette.text.primary',
              flex: '1 1 auto',
              fontWeight: 600,
              minWidth: 0,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },

            '.treePreview__content': {
              flex: '1 1 auto',
              minHeight: 0,
              minWidth: 0,
              overflow: 'auto',
              p: 4,
            },

            '.tree': {
              minHeight: '100%',
            },
          },

          '&.result__preview--process, &.result__preview--form': {
            background: 'palette.background.default',
            display: 'flex',
            flexDirection: 'column',
            gap: 0,
            overflow: 'hidden',
            p: 0,

            '.previewAccordion__section': {
              background: 'palette.background.paper',
              display: 'flex',
              flexDirection: 'column',
              minHeight: 0,
              minWidth: 0,
              overflow: 'hidden',
              transition:
                'flex-basis 220ms ease, flex-grow 220ms ease, opacity 180ms ease',
            },

            '&.result__preview--resizing': {
              '.previewAccordion__section': {
                transition: 'none',
              },
            },

            '.previewAccordion__section--expanded': {
              minHeight: '50px',
              height: '100%',
            },

            '.previewAccordion__section--collapsed': {
              '.previewAccordion__content': {
                opacity: 0,
                pointerEvents: 'none',
              },
            },

            '.previewAccordion__header': {
              alignItems: 'center',
              background: 'palette.background.paper',
              borderBottom: '1px solid',
              borderColor: 'palette.border.field',
              display: 'flex',
              flex: '0 0 36px',
              gap: 2,
              minHeight: '36px',
              px: 2,
            },

            '.previewAccordion__title': {
              color: 'palette.text.primary',
              flex: '1 1 auto',
              fontWeight: 600,
              minWidth: 0,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },

            '.previewAccordion__content': {
              flex: '1 1 auto',
              minHeight: 0,
              minWidth: 0,
              opacity: 1,
              overflow: 'hidden',
              transition: 'opacity 180ms ease',
            },

            '.detailsPreview__viewport': {
              boxSizing: 'border-box',
              display: 'flex',
              flexDirection: 'column',
              gap: 3,
              height: '100%',
              minHeight: 0,
              minWidth: 0,
              overflow: 'auto',
              p: 4,
            },

            '&.result__preview--details .processPreview__detailsCard, .formPreview__viewport > .processPreview__detailsCard':
              {
                background: 'palette.background.paper',
                border: '1px solid',
                borderColor: 'palette.border.field',
                borderRadius: 'default',
                boxShadow: 'default',
                flex: '0 0 auto',
                maxWidth: '920px',
                minWidth: 0,
                mx: 'auto',
                overflow: 'hidden',
                width: '100%',
              },

            '&.result__preview--details .processPreview__header, .formPreview__viewport > .processPreview__detailsCard .processPreview__header':
              {
                background: 'palette.background.paper',
                border: 0,
                borderBottom: '1px solid',
                borderColor: 'palette.border.field',
                borderRadius: 0,
                boxShadow: 'none',
                gap: 1,
                p: 3,
              },

            '&.result__preview--details .processPreview__title, .formPreview__viewport > .processPreview__detailsCard .processPreview__title':
              {
                color: 'palette.text.primary',
                fontWeight: 700,
                minWidth: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              },

            '&.result__preview--details .processPreview__detailsList, .formPreview__viewport > .processPreview__detailsCard .processPreview__detailsList':
              {
                borderCollapse: 'collapse',
                m: 0,
                tableLayout: 'fixed',
                width: '100%',

                'tbody tr:first-of-type .processPreview__detailsLabel, tbody tr:first-of-type .processPreview__detailsValue':
                  {
                    borderTop: 0,
                  },
              },

            '&.result__preview--details .processPreview__detailsLabel, .formPreview__viewport > .processPreview__detailsCard .processPreview__detailsLabel':
              {
                borderTop: '1px solid',
                borderColor: 'palette.border.field',
                color: 'palette.text.disabled',
                fontWeight: 600,
                minWidth: 0,
                p: 3,
                textAlign: 'left',
                verticalAlign: 'top',
                width: '180px',
              },

            '&.result__preview--details .processPreview__detailsValue, .formPreview__viewport > .processPreview__detailsCard .processPreview__detailsValue':
              {
                borderTop: '1px solid',
                borderColor: 'palette.border.field',
                color: 'palette.text.primary',
                minWidth: 0,
                overflowWrap: 'anywhere',
                p: 3,
                verticalAlign: 'top',
              },

            '&.result__preview--details .processPreview__empty, .formPreview__viewport > .processPreview__detailsCard .processPreview__empty':
              {
                color: 'palette.text.disabled',
                p: 3,
              },

            '.processPreview__valueList': {
              display: 'flex',
              flexWrap: 'wrap',
              columnGap: 1,
              minWidth: 0,
              rowGap: 1,
            },

            '.processPreview__valueItem': {
              color: 'palette.text.primary',
              maxWidth: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },

            '.processPreview__valueSeparator': {
              color: 'palette.text.disabled',
            },

            '.processPreview__taskFloatingPanel': {
              background: 'palette.background.paper',
              border: '1px solid',
              borderColor: 'palette.border.field',
              borderRadius: 'default',
              boxShadow: 'default',
              boxSizing: 'border-box',
              flex: '0 0 auto',
              maxWidth: '920px',
              minWidth: 0,
              mx: 'auto',
              p: 3,
              width: '100%',
              zIndex: 2,
            },

            '.processPreview__taskFloatingTitle': {
              color: 'palette.text.primary',
              fontWeight: 700,
              lineHeight: 1.35,
              minWidth: 0,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },

            '.processPreview__taskFloatingPerformer': {
              color: 'palette.text.disabled',
              fontSize: 1,
              lineHeight: 1.35,
              mt: 1,
              minWidth: 0,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },

            '.processPreview__contextFormsToggle': {
              alignItems: 'center',
              color: 'palette.text.primary',
              cursor: 'pointer',
              display: 'flex',
              fontSize: 1,
              gap: 2,
              lineHeight: 1.35,
              mt: 2,
              userSelect: 'none',
            },

            '.processPreview__contextFormsToggleInput': {
              flex: '0 0 auto',
              m: 0,
            },

            '.processPreview__itemList': {
              display: 'flex',
              flexDirection: 'column',
              gap: 0,
              listStyle: 'none',
              m: 0,
              p: 0,
            },

            '.processPreview__item': {
              background: 'palette.background.paper',
              border: 0,
              borderTop: '1px solid',
              borderColor: 'palette.border.field',
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              minWidth: 0,
              outline: 'none',
              p: 3,

              '&:first-of-type': {
                borderTop: 0,
              },
            },

            '.processPreview__itemTitle': {
              color: 'palette.text.primary',
              fontWeight: 700,
              minWidth: 0,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },

            '.processPreview__itemMeta': {
              color: 'palette.text.disabled',
              minWidth: 0,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },

            '.entityPreview__instanceItem': {
              alignItems: 'center',
              cursor: 'default',
              flexDirection: 'row',
              gap: 2,
            },

            '.entityPreview__instanceItem .processPreview__itemTitle': {
              flex: '0 1 auto',
              maxWidth: '40%',
            },

            '.entityPreview__instanceItem .processPreview__valueList': {
              flex: '1 1 auto',
              flexWrap: 'nowrap',
              overflow: 'hidden',
              rowGap: 0,
            },

            '.previewAccordion__resizeHandle': {
              background: 'transparent',
              cursor: 'row-resize',
              flex: '0 0 4px',
              height: '4px',
              minHeight: '4px',
              outline: 'none',
              position: 'relative',
              transition: 'background 200ms',

              '&:hover': {
                backgroundColor: 'palette.border.field',
              },
            },

            '.previewAccordion__jointResizeHandle': {
              background: 'transparent',
              border: '1px solid transparent',
              cursor: 'move',
              height: '12px',
              left: '-6px',
              outline: 'none',
              position: 'absolute',
              top: '-4px',
              touchAction: 'none',
              width: '12px',
              zIndex: 2,

              '&:hover, &:focus': {
                backgroundColor: 'palette.background.paper',
                borderColor: 'palette.border.field',
              },
            },

            '.previewAccordion__imageViewport': {
              ...bpmnMapViewportStyles,
            },

            '.previewAccordion__emptyImage': {
              alignItems: 'center',
              color: 'palette.text.primary',
              display: 'flex',
              height: '100%',
              justifyContent: 'center',
              minHeight: 0,
              p: 4,
              textAlign: 'center',
              width: '100%',
            },

            '.previewAccordion__treeContent': {
              overflow: 'auto',
              p: 4,
            },

            '&.result__preview--process': {
              '.previewAccordion__content': {
                background: 'palette.background.default',
                overflow: 'auto',
              },

              '&.result__preview--bpmExpanded': {
                background: 'palette.background.paper',
                p: 0,

                '.previewAccordion__bpmExpanded': {
                  height: '100%',
                  minHeight: 0,
                  minWidth: 0,
                  overflow: 'hidden',
                  position: 'relative',
                  width: '100%',
                },

                '.previewAccordion__bpmExpanded > .bpmGraphViewer': {
                  height: '100%',
                  minHeight: 0,
                  minWidth: 0,
                  width: '100%',
                },
              },

              '.processPreview__stack': {
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                minWidth: 0,
                p: 4,
              },

              '.processPreview__header': {
                background: 'palette.background.paper',
                border: '1px solid',
                borderColor: 'palette.border.field',
                borderRadius: 'default',
                boxShadow: 'default',
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                minWidth: 0,
                p: 3,
              },

              '.processPreview__detailsCard .processPreview__header': {
                border: 0,
                borderBottom: '1px solid',
                borderColor: 'palette.border.field',
                borderRadius: 0,
                boxShadow: 'none',
              },

              '.processPreview__title': {
                color: 'palette.text.primary',
                fontWeight: 700,
                minWidth: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              },

              '.processPreview__subtitle': {
                color: 'palette.text.disabled',
                minWidth: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              },

              '.processPreview__map': {
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                minWidth: 0,
              },

              '.processPreview__detailsCard': {
                background: 'palette.background.paper',
                border: '1px solid',
                borderColor: 'palette.border.field',
                borderRadius: 'default',
                boxShadow: 'default',
                flex: '0 0 auto',
                minWidth: 0,
                overflow: 'hidden',
              },

              '.processPreview__mapCard': {
                background: 'palette.background.paper',
              },

              '.processPreview__mapBody': {
                background: 'palette.background.paper',
                minWidth: 0,
                p: 3,
              },

              '.processPreview__detailsList': {
                borderCollapse: 'collapse',
                m: 0,
                tableLayout: 'fixed',
                width: '100%',

                'tbody tr:first-of-type .processPreview__detailsLabel, tbody tr:first-of-type .processPreview__detailsValue':
                  {
                    borderTop: 0,
                  },
              },

              '.processPreview__detailsLabel': {
                borderTop: '1px solid',
                borderColor: 'palette.border.field',
                color: 'palette.text.disabled',
                fontWeight: 600,
                minWidth: 0,
                p: 3,
                textAlign: 'left',
                verticalAlign: 'top',
                width: '180px',
              },

              '.processPreview__detailsValue': {
                borderTop: '1px solid',
                borderColor: 'palette.border.field',
                color: 'palette.text.primary',
                minWidth: 0,
                overflowWrap: 'anywhere',
                p: 3,
                verticalAlign: 'top',
              },

              '.processPreview__empty': {
                color: 'palette.text.disabled',
                p: 3,
              },

              '.processPreview__itemList': {
                display: 'flex',
                flexDirection: 'column',
                gap: 0,
                listStyle: 'none',
                m: 0,
                p: 0,
              },

              '.processPreview__item': {
                background: 'palette.background.paper',
                border: 0,
                borderTop: '1px solid',
                borderColor: 'palette.border.field',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                minWidth: 0,
                outline: 'none',
                p: 3,

                '&:first-of-type': {
                  borderTop: 0,
                },

                '&:hover, &:focus-visible': {
                  background: 'palette.background.default',
                },
              },

              '.processPreview__itemTitle': {
                color: 'palette.text.primary',
                fontWeight: 700,
                minWidth: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              },

              '.processPreview__itemMeta': {
                color: 'palette.text.disabled',
                minWidth: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              },

              '.processPreview__valueList': {
                display: 'flex',
                flexWrap: 'wrap',
                columnGap: 1,
                minWidth: 0,
                rowGap: 1,
              },

              '.processPreview__valueItem': {
                color: 'palette.text.primary',
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              },

              '.processPreview__valueSeparator': {
                color: 'palette.text.disabled',
              },

              '.processPreview__transition': {
                alignItems: 'center',
                background: 'palette.background.paper',
                border: 0,
                borderTop: '1px solid',
                borderColor: 'palette.border.field',
                color: 'palette.text.primary',
                display: 'flex',
                flexWrap: 'wrap',
                gap: 2,
                minWidth: 0,
                p: 3,

                '&:first-of-type': {
                  borderTop: 0,
                },
              },

              '.processPreview__transitionArrow': {
                color: 'palette.text.disabled',
                flex: '0 0 auto',
                fontWeight: 700,
              },

              '.processPreview__taskForms': {
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                minWidth: 0,
              },

              '.processPreview__taskFormSlot--context': {
                display: 'none',
              },

              '.processPreview__taskForms:has(.processPreview__contextFormsToggleInput:checked) .processPreview__taskFormSlot--context':
                {
                  display: 'block',
                },
            },

            '&.result__preview--form': {
              '.previewAccordion__content': {
                background: 'palette.background.default',
                boxSizing: 'border-box',
                minHeight: 0,
                minWidth: 0,
                overflow: 'auto',
                p: 4,
              },

              '.formPreview__viewport.processPreview__taskForms': {
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                height: 'auto',
                minHeight: 0,
                minWidth: 0,
                overflow: 'visible',
                width: '100%',
              },

              '.formPreview__accordion': {
                maxWidth: '920px',
                mx: 'auto',
                width: '100%',

                '.accordion__item': {
                  boxShadow: 'default',
                },

                '.accordion__item__button[class]': {
                  borderRadius: 'default',
                  p: '10px 15px',
                  userSelect: 'unset',
                  width: '100%',

                  '.button__content': {
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    width: '100%',
                  },
                },

                '.accordion__item__button__label': {
                  color: 'palette.primary.contrastText',
                },

                '.accordion__item__button__rightGroup': {
                  display: 'flex',
                },

                '.accordion__item__content': {
                  background: 'palette.background.paper',
                  borderRadius: 'none',
                },

                '.accordion__item__content > .formPreview__form': {
                  boxShadow: 'none',
                  p: spacing(5),
                },
              },

              '.formPreview__form': {
                alignContent: 'start',
                boxSizing: 'border-box',
                gap: spacing(5),
                width: '100%',
              },

              '.formPreview__field': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'stretch',
                minHeight: '64px',
                minWidth: 0,
              },

              '.formPreview__field.field__area': {
                minHeight: '128px',
              },

              '.formPreview__field.field__file': {
                minHeight: '128px',
              },

              '.formPreview__grid': {
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                minWidth: 0,
              },

              '.formPreview__gridTitle': {
                fontWeight: 600,
                minWidth: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              },

              '.formPreview__gridTableScroller': {
                minWidth: 0,
                overflowX: 'auto',
                width: '100%',
              },

              '.formPreview__gridTable': {
                minWidth: '640px',
                tableLayout: 'fixed',
                width: '100%',

                'th, td': {
                  minWidth: '130px',
                },
              },

              '.formPreview__gridCellControl': {
                minHeight: '36px',
                minWidth: 0,

                '.field__title_container, .radio_label': {
                  display: 'none',
                },

                '.field__label': {
                  gap: 0,
                },

                '.fieldset, .radio__layout__wrapper': {
                  minHeight: '36px',
                },

                '.option__container': {
                  minHeight: '34px',
                },

                '.formPreview__fileDrop': {
                  minHeight: '36px',
                  p: 2,
                },

                '.formPreview__inputHost textarea': {
                  minHeight: '38px',
                },
              },

              '.field__label': {
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                height: '100%',
                minWidth: 0,
                width: '100%',
              },

              '.field__title_container': {
                alignItems: 'center',
                display: 'flex',
                minHeight: '20px',
                minWidth: 0,
              },

              '.field__title': {
                alignItems: 'center',
                display: 'inline-flex',
                gap: 1,
                maxWidth: '100%',
                minWidth: 0,
                overflow: 'hidden',
              },

              '.formPreview__fieldTitleText': {
                minWidth: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              },

              '.required': {
                color: 'palette.error.main',
                flex: '0 0 auto',
                textDecoration: 'none',
              },

              '.field__control_container': {
                alignItems: 'center',
                display: 'flex',
                flex: '1 1 auto',
                minHeight: 0,
                minWidth: 0,
                width: '100%',
              },

              '.formPreview__inputHost': {
                display: 'flex',
                minWidth: 0,
                width: '100%',

                'input, select, textarea': {
                  boxSizing: 'border-box',
                  minWidth: 0,
                  width: '100%',
                },

                textarea: {
                  minHeight: '92px',
                },
              },

              '.fieldset': {
                border: 0,
                display: 'flex',
                height: '100%',
                m: 0,
                minWidth: 0,
                p: 0,
              },

              '.radio__layout__wrapper': {
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                minWidth: 0,
                width: '100%',
              },

              '.radio_label': {
                m: 0,
                minHeight: '20px',
                minWidth: 0,
                p: 0,
              },

              '.option__container': {
                alignItems: 'center',
                display: 'flex',
                flexWrap: 'wrap',
                gap: 3,
                minHeight: '34px',
                minWidth: 0,
              },

              '.radio': {
                alignItems: 'center',
                display: 'inline-flex',
                gap: 2,
                minWidth: 0,
              },

              '.radio input': {
                m: 0,
              },

              '.formPreview__optionSkeleton': {
                backgroundColor: 'palette.border.field',
                borderRadius: 'default',
                height: '8px',
                opacity: 0.8,
                width: '72px',
              },

              '.formPreview__optionLabel': {
                maxWidth: '160px',
                minWidth: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              },

              '.field__check': {
                justifyContent: 'center',
              },

              '.field__check .label': {
                alignItems: 'center',
                display: 'flex',
                gap: 2,
                minWidth: 0,
              },

              '.field__check .field__title': {
                flex: '1 1 auto',
              },

              '.fake__label': {
                display: 'none',
              },

              '.formPreview__buttonHost': {
                alignItems: 'center',
                display: 'flex',
                height: '100%',
                minWidth: 0,

                button: {
                  maxWidth: '100%',
                  minWidth: 0,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                },
              },

              '.formPreview__fileDrop': {
                alignItems: 'center',
                border: '2px dashed',
                borderColor: 'palette.border.article',
                borderRadius: '7px',
                display: 'flex',
                gap: 3,
                minHeight: '74px',
                p: 3,
                width: '100%',
              },

              '.formPreview__fileIcon': {
                border: '1px solid',
                borderColor: 'palette.border.field',
                borderRadius: 'default',
                flex: '0 0 28px',
                height: '28px',
                position: 'relative',

                '&:before': {
                  borderBottom: '1px solid',
                  borderBottomColor: 'palette.border.field',
                  borderLeft: '1px solid',
                  borderLeftColor: 'palette.border.field',
                  content: '""',
                  height: '8px',
                  position: 'absolute',
                  right: '-1px',
                  top: '-1px',
                  width: '8px',
                },
              },

              '.formPreview__fileLine': {
                backgroundColor: 'palette.border.field',
                borderRadius: 'default',
                height: '8px',
                maxWidth: '180px',
                width: '45%',
              },
            },
          },
        },

        '.prompt__area': {
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          height: '100%',
          minHeight: 0,
          minWidth: 0,
          border: '1px solid',
          borderColor: 'palette.border.field',
          p: 0,

          '.prompt__area__content': {
            display: 'flex',
            flex: '1 1 auto',
            flexDirection: 'column',
            minHeight: 0,
            minWidth: 0,
            overflow: 'hidden',
            p: 3,
          },

          '&.preview__mode > textarea': {
            display: 'none',
          },

          '&.multiple_fields': {
            minHeight: '100%',
            overflow: 'auto',
            p: 0,
            position: 'relative',

            '.prompt__area__content': {
              overflow: 'auto',
              p: 4,
              position: 'relative',
            },
          },

          '&:not(.multiple_fields)': {
            '& *:focus': {
              outline: 'none',
            },

            textarea: {
              border: 'none',
            },
          },

          '.prompt__enhancer': {
            flexBsis: '70px',
            display: 'flex',

            textarea: {
              borderTop: '1px solid',
              borderTopColor: 'palette.border.field',
            },
          },

          textarea: {
            textWrap: 'wrap',
            flexGrow: '1',
            flexBasis: '100%',
            display: 'block',
            resize: 'none',
            p: 3,
          },

          '.progress__messages': {
            color: 'wheat',
            flexBasis: '100%',
            p: 3,
          },

          '.ddlSourcePreview': {
            background: 'palette.background.default',
            color: 'palette.text.primary',
            display: 'flex',
            flex: '1 1 auto',
            flexDirection: 'column',
            fontFamily: 'monospace',
            minHeight: 0,
            minWidth: 0,
            overflow: 'hidden',
            width: '100%',

            '.ddlSourcePreview__content': {
              flex: '1 1 auto',
              minHeight: 0,
              minWidth: 0,
              overflow: 'auto',
            },

            '.ddlSourcePreview__pre': {
              fontFamily: 'monospace',
              m: 0,
              minHeight: '100%',
              minWidth: 'max-content',
              p: 0,
              tabSize: 2,
            },

            '.ddlSourcePreview__code': {
              display: 'block',
              minWidth: 'max-content',
            },

            '.ddlSourcePreview__line': {
              display: 'grid',
              gridTemplateColumns: '24px max-content minmax(0, 1fr)',
              minWidth: 'max-content',
            },

            '.ddlSourcePreview__foldSlot': {
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',
              userSelect: 'none',
              width: '24px',
            },

            '.ddlSourcePreview__foldButton.iconButton': {
              background: 'transparent',
              border: 'none',
              color: 'palette.text.disabled',
              height: '22px',
              minHeight: '22px',
              minWidth: '22px',
              width: '22px',

              '&:hover, &:focus-visible': {
                color: 'palette.primary.main',
              },
            },

            '.ddlSourcePreview__lineNumber': {
              borderRight: '1px solid',
              borderColor: 'palette.border.field',
              color: 'palette.text.disabled',
              minWidth: '42px',
              px: 2,
              textAlign: 'right',
              userSelect: 'none',
            },

            '.ddlSourcePreview__lineCode': {
              fontFamily: 'monospace',
              minWidth: 0,
              px: 3,
              whiteSpace: 'pre',
            },

            '.ddlSourcePreview__token--keyword': {
              color: 'palette.primary.main',
              fontWeight: 700,
            },

            '.ddlSourcePreview__token--identifier': {
              color: 'palette.text.primary',
            },

            '.ddlSourcePreview__token--string': {
              color: 'palette.success.dark',
            },

            '.ddlSourcePreview__token--number': {
              color: 'palette.warning.main',
            },

            '.ddlSourcePreview__token--operator, .ddlSourcePreview__token--brace':
              {
                color: 'palette.text.disabled',
                fontWeight: 700,
              },

            '.ddlSourcePreview__token--comment': {
              color: 'palette.text.disabled',
              fontStyle: 'italic',
            },

            '.ddlSourcePreview__foldMarker': {
              color: 'palette.text.disabled',
              fontWeight: 700,
            },
          },

          '.promptStructureTree': {
            display: 'flex',
            flexDirection: 'column',
            flex: '1 1 auto',
            minHeight: 0,
            overflow: 'hidden',
            width: '100%',

            '.promptStructureTree__content': {
              flex: '1 1 auto',
              minHeight: 0,
              overflow: 'auto',
            },

            '.mobxtree': {
              minHeight: '100%',
              p: 0,
            },

            '.mobxtree__node__label__wrapper': {
              alignItems: 'center',
              display: 'flex',
              minWidth: 0,
              width: '100%',
            },

            '.mobxtree__node__label': {
              flex: '1 1 auto',
              minWidth: 0,
              userSelect: 'text',
              whiteSpace: 'nowrap',
            },

            '.promptStructureTree__label': {
              alignItems: 'center',
              display: 'flex',
              gap: 2,
              maxWidth: '100%',
              minWidth: 0,
              py: 1,
              whiteSpace: 'nowrap',
              width: '100%',
            },

            '.promptStructureTree__title': {
              color: 'palette.text.primary',
              flex: '1 1 auto',
              minWidth: 0,
              overflow: 'hidden',
              overflowWrap: 'normal',
              textOverflow: 'ellipsis',
              userSelect: 'text',
              whiteSpace: 'nowrap',
            },

            '.promptStructureTree__count': {
              color: 'palette.text.secondary',
              flex: '0 0 auto',
              userSelect: 'text',
            },

            '.promptStructureTree__label--reference': {
              '.promptStructureTree__title': {
                color: 'palette.primary.main',
                cursor: 'pointer',
                textDecoration: 'underline',
                textDecorationThickness: '1px',
                textUnderlineOffset: '2px',
              },
            },

            '.promptStructureTree__label--error': {
              '.promptStructureTree__title': {
                color: 'palette.error.main',
              },
            },
          },

          '&:not(.preview__mode) > .progress__messages': {
            display: 'none',
          },

          '&.preview__mode': {
            background: '#333',

            '.attachedImages': {
              button: { display: 'none' },
            },
          },

          '.attachedImages': {
            bottom: '-8px',
            left: '-8px',
            position: 'sticky',
          },
        },

        '.renderer__buttons > *:not(.info__button)': {
          display: 'none',
        },
      },

      '.toolbar': {
        gap: '4px',

        '.regenerate__toolbarTitle': {
          alignItems: 'center',
          color: 'palette.text.primary',
          display: 'flex',
          flex: '0 1 auto',
          fontSize: '13px',
          fontWeight: 600,
          lineHeight: '20px',
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          marginRight: '8px',
        },

        '.regenerate__closeButton': {
          flexShrink: 0,
        },

        select: {
          width: '150px',
        },
      },
    },

    '.attachedImages': {
      alignItems: 'end',
      display: 'flex',
      gap: 2,
      padding: 2,
      flexShrink: '0',
      flexBasis: 'min-content',

      '.attach__button': {
        height: '40px',
        variant: 'buttons.icon-only',
        width: '40px',

        svg: {
          height: '25px',
          width: '25px',
        },
      },

      '.attached__image': {
        cursor: 'pointer',
        position: 'relative',
      },

      '.remove__attached': (theme) => ({
        position: 'absolute',
        top: 0,
        right: 0,
        ...theme.palette.getStatesFromDefinition({
          backgroundColor: 'palette.background.default',
          color: 'palette.text.primary',
        }),
      }),

      img: {
        height: '70px',
        width: '70px',
      },
    },
  },

  removeOrphansModal: {
    variant: 'layout.common.modals.confirm',

    '.itemsList': {
      maxHeight: '70vh',
      overflow: 'auto',
      display: 'flex',
      flexDirection: 'column',

      button: {
        justifyContent: 'start',
      },
    },
  },

  scenesMenu: {
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    gap: 3,
    listStyle: 'none',
    overflow: 'auto',

    button: (theme) => ({
      width: '100%',
      justifyContent: 'start',
      borderWidth: '1px',

      ...theme.palette.getColorStates({
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        borderColor: theme.palette.border.section,
      }),
    }),

    '.sceneMenu__item': {
      background: '#f5f5f5',
      border: '1px solid',
      borderColor: 'palette.border.section',
      borderBottom: 'none',

      '& > button': {
        borderTop: 'none',
        borderLeft: 'none',
        borderRight: 'none',
      },

      '.sceneMenu__submenu': {
        borderBottom: '1px solid',
        borderColor: 'palette.border.section',
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
      },
    },

    '.selected': {
      fontWeight: 'bold',
      textDecoration: 'underline',
    },

    '.sceneMenu__submenu': {
      p: 3,
    },
  },

  sortTasksModal: {
    display: 'flex',
    gap: 5,
    width: '100%',

    '.modal__content': {
      p: 5,
    },

    '.sortableList': {
      width: '100%',
    },

    '.sortTasksModal__taskDetails': {
      border: '1px solid',
      borderColor: 'palette.border.section',
      display: 'flex',
      flexDirection: 'column',
      gap: 5,
      p: 5,
      width: '500px',
    },

    '& label': {
      display: 'flex',
      gap: 3,
    },

    select: {
      width: '100%',
    },

    '.sortableList__item': {},

    '.sortable__task': {
      border: '1px solid',
      borderColor: 'palette.border.section',
      p: 3,
    },

    '.sortable__task.selected': (theme) => ({
      backgroundColor: theme.palette.getColor(
        theme.palette.background.paper,
        'selected',
      ),
      color: theme.palette.getContrastText(
        theme.palette.getColor(theme.palette.background.paper, 'selected'),
      ),
    }),

    '.taskflow__destinations': {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },

    '.taskflow__destination': {
      alignItems: 'center',
      display: 'flex',
      gap: 3,
      p: 3,
    },

    button: {
      flexBasis: '24px',
      height: '24px',
      width: '24px',
    },

    svg: {
      height: '16px',
      width: '16px',
    },
  },

  templates: {},

  vacuumSelector: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    overflow: 'auto',
    position: 'relative',
    height: '100%',

    '.fieldWrapper.checkbox': {
      display: 'flex',
      gap: 3,
      flexDirection: 'row-reverse',
      alignItems: 'center',
      justifyContent: 'start',

      '.checkbox': {
        display: 'inline-block',
        height: '32px',
      },
    },

    '.ConfirmBox': {
      display: 'flex',
      alignItems: 'end',
      justifyContent: 'end',
      position: 'sticky',
      bottom: '0',
      marginRight: '5px',
    },
  },

  variantsEditorModal: {
    variant: 'layout.util.collector.modal',

    textarea: {
      height: '50vh',
    },

    '.modal__main': {
      maxWidth: 'min(70vw, calc(100vw - 50px))',
      width: '900px',
    },
  },
};

export default projectAnalysis;
